import { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

import Iconify from '../../../../reusable-components/iconify';
import { NotificationDialog } from '../../../../reusable-components/dialog';
import { useScopeCheck } from '../../../../reusable-components/scopes';

UploadManualInvoiceButtons.propTypes = {
  openInvoiceUploader: PropTypes.bool,
  setOpenInvoiceUploader: PropTypes.func,
};
export default function UploadManualInvoiceButtons({ openInvoiceUploader, setOpenInvoiceUploader }) {
  const newInvoiceAccess = useScopeCheck(['Manual-Invoice'], true);
  const hasEditAccess = useScopeCheck(['ManualInvoice-Edit'], true);
  const [showNotification, setShowNotification] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        color="secondary"
        onClick={() => {
          if (!newInvoiceAccess || !hasEditAccess) {
            setShowNotification(true);
            return;
          }
          setOpenInvoiceUploader((prev) => !prev);
        }}
        startIcon={openInvoiceUploader ? <Iconify icon="mdi:tray-arrow-up" /> : <Iconify icon="eva:plus-outline" />}
      >
        {openInvoiceUploader ? 'Upload invoice' : 'Manual invoice'}
      </Button>
      {showNotification && (
        <NotificationDialog
          handleClose={() => {
            setShowNotification(false);
          }}
          title="Permission missing"
          content={"You don't have permission to create an invoice."}
        />
      )}
    </>
  );
}
